<div class="loading-container">
  <div class="loading-wrapper">
    <!-- Animated Circles -->
    <!-- <div class="loading-circles">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
    </div> -->
    
    <!-- Radio Wave Animation -->
    <div class="radio-waves">
      <div class="wave wave-1"></div>
      <div class="wave wave-2"></div>
      <div class="wave wave-3"></div>
    </div>
    
    <!-- Loading Text -->
    <p class="loading-text">
      <span class="loading-dots">
        <span>جاري التحميل</span>
      </span>
    </p>
  </div>
</div>